/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type {
  DomainToken,
  ProvisionDevicesResponse,
  ProvisionDevicesResponseV2
} from "@tivocorp/data-domain-lib";

import type { UnityRootState } from "../../UnityAppStore";

export const selectBodyId = (state: UnityRootState): string | undefined => {
  const provisionResponse = state.signIn.provisionResponse;
  return provisionResponse !== undefined && provisionResponse !== null
    ? provisionResponse.bodyId
    : undefined;
};

export const selectDomainToken = (state: UnityRootState): DomainToken | null =>
  state.signIn.domainToken;

export const selectIsTokenRehydrating = (state: UnityRootState): boolean =>
  state.signIn.isTokenRehydrating;

export const selectIsRefreshingToken = (state: UnityRootState): boolean =>
  state.signIn.isRefreshingToken;

export const selectRefreshError = (state: UnityRootState): string =>
  state.signIn.refreshError;

export const selectIsAuthenticated = (state: UnityRootState): boolean =>
  state.signIn.domainToken !== null;

// TODO: When soft logout is implemented (without page reload), add:
//   Sage.flush();
//   Sage.setBodyId(DEFAULT_BODY_ID);
// partnerId is MSO/device-level — does not change between users, no reset needed.

export const selectProvisionResponse = (
  state: UnityRootState
): ProvisionDevicesResponse | ProvisionDevicesResponseV2 | undefined =>
  state.signIn.provisionResponse;

export const selectIsSignedIn = (state: UnityRootState): boolean =>
  state.signIn.domainToken !== null &&
  state.signIn.provisionResponse !== undefined;
